import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const location = window.location.pathname.toLowerCase();
console.log("Location:", location);
const baseName = process.env.REACT_APP_BASENAME;

let basePath = baseName;
if (baseName === "/pasadena") {
  basePath = basePath + "/";
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route
          path={baseName}
          element={<App />}
        />
        <Route
          path={location}
          element={<App />}
        />
      </Routes>
    </Router>
  </React.StrictMode>,
);

reportWebVitals();
